import React, { useState, useEffect, useMemo, useRef } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Button,
  Checkbox,
  Paper,
  CircularProgress,
  Modal,
  Box,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPrint, faSave } from "@fortawesome/free-solid-svg-icons";
import usePrintInvoicesSingle from "../../../hooks/UsePrintInvoices";
import Pagination from "@mui/material/Pagination";
import "jspdf-autotable";
import {
  fetchDataWithRetries,
  putData,
  fetch,
} from "../../../Component/function/FunctionApi";
import * as XLSX from "xlsx";
import "./TableBills.css";
import Swal from "sweetalert2";
import usePrintInvoices from "../../../hooks/UsePrint";
import useShowInvoice from "../../../hooks/invoice/ShowInvoice";
import useExportExcel from "../../../hooks/ExportExcel/userExportExcel";
import RepresentativeSelector from "../../../Component/RepresentativeSelector/RepresentativeSelector";
import DelayInvoiceDialog from "../../../Component/DelayInvoiceDialog/DelayInvoiceDialog";

// Custom hook for debouncing input values
const useDebounce = (value, delay) => {
  const [debouncedValue, setDebouncedValue] = useState(value);
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);
    return () => clearTimeout(handler);
  }, [value, delay]);
  return debouncedValue;
};

const DataTable = () => {
  const printRepInvoices = usePrintInvoices();
  const { handleExportToExcel } = useExportExcel();
  const [rows, setRows] = useState({ data: [] });
  const [itemsToShow, setItemsToShow] = useState(10);
  const printRepInvoicesSingle = usePrintInvoicesSingle();
  console.log(rows);
  const [searchTerms, setSearchTerms] = useState({});
  const [selectedRows, setSelectedRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState("");
  const debouncedSearchTerms = useDebounce(searchTerms, 300);
  const [statusMessage, setStatusMessage] = useState(null);
  const [openRepModal, setOpenRepModal] = useState(false);
  const [representatives, setRepresentatives] = useState([]);
  const [selectedRepresentative, setSelectedRepresentative] = useState("");
  const [selectedDate, setSelectedDate] = useState(() => {
    const today = new Date();
    return today.toISOString().split("T")[0];
  });
  const invoiceCodeRef = useRef();
  const invoiceDateRef = useRef();
  const customerRef = useRef();
  const addressRef = useRef();
  const governorateRef = useRef();
  const phoneRef = useRef();
  const invoiceCategoriesRef = useRef();
  const dateCreatedRef = useRef();
  const userNameRef = useRef();
  const statusRef = useRef();
  const totalPriceRef = useRef();
  const [status, setApiStatus] = useState(null);
  const [statusMessageModalOpen, setStatusMessageModalOpen] = useState(false);
  const [showPrintModel, setShowPrintModel] = useState(false);
  const [showDelayModal, setShowDelayModal] = useState(false);
  const [isDelayingInvoices, setIsDelayingInvoices] = useState(false);
  const { showInvoice } = useShowInvoice();

  const handelPrintDaily = async () => {
    console.log("start print");

    console.log(selectedRepresentative, selectedDate);

    try {
      const url = `Represntative/get-dailyDateOfRepresntative?represntativeId=${selectedRepresentative}&dateDaily=${selectedDate}`;
      console.log(url);
      const response = await fetch(url);
      const data = await response.data;
      console.log(response);
      if (data[0].invoices.length === 0) {
        console.log("error");
        setShowPrintModel(false);
        Swal.fire({
          icon: "info",
          title: "لا يوجد  فواتير",
          text: "لا يوجد فواتير لهذا المندوب  في هذه اليوم",
        });
      } else {
        console.log(data);
        printRepInvoices(data);
      }
    } catch (error) {
      Swal.fire({
        icon: "خطا",
        title: "Error",
        text: "حدث خطاء في جلب البيانات اليومية",
      });
      console.error("Error fetching daily data:", error);
    }
  };

  const fetchInvoices = async (countParam) => {
    setLoading(true);
    try {
      const count = typeof countParam === "number" ? countParam : itemsToShow;
      await fetchDataWithRetries(
        `Invoice/GetInvoicesWithNoRepresentative?count=${count}`,
        setRows,
        setApiStatus
      );

      await fetchDataWithRetries(
        "Represntative/get-Represntatives",
        setRepresentatives,
        setApiStatus
      );
    } catch (error) {
      console.log("error", error);
      if (error.response && error.response.status === 403) {
        setError("ليس لديك صلاحية للوصول إلى إدارة الفواتير");
      } else {
        setError("Error fetching data after multiple retries");
      }
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchInvoices(itemsToShow);
  }, []);

  const handleSearch = (column, value) => {
    setSearchTerms((prev) => ({ ...prev, [column]: value }));
  };

  let filteredRows = useMemo(() => {
    if (!rows.data) return [];

    return rows.data.filter((row) => {
      return Object.entries(debouncedSearchTerms).every(([column, value]) => {
        const searchTerm = value?.toString().trim().toLowerCase() || "";

        if (!searchTerm) return true; // skip empty search terms

        switch (column) {
          case "governorate":
            const searchParts = searchTerm.split("-").map((part) => part.trim());
            return searchParts.some(
              (part) => row.governorate?.name?.toLowerCase().includes(part)
            );

          case "itemsCount":
            return row.itemsCount?.toString().includes(searchTerm);

          case "fullName":
            return row.representative?.fullName
              ?.toLowerCase()
              .includes(searchTerm);

          case "invoiceCategories":
            return row.invoiceCategories.find((category) =>
              category?.category?.name.toLowerCase().includes(searchTerm)
            );

          case "invoiceCode":
            // Handle multiple invoice codes separated by "-"
            if (searchTerm.includes("-")) {
              const searchParts = searchTerm
                .split("-")
                .map((part) => part.trim())
                .filter(Boolean);
              return searchParts.some(
                (part) => row.invoiceCode?.toLowerCase() === part
              );
            }
            return row.invoiceCode?.toLowerCase() === searchTerm;

          default:
            return row[column]?.toString().toLowerCase().includes(searchTerm);
        }
      });
    });
  }, [rows, debouncedSearchTerms]);

  const handleItemsToShowChange = (event) => {
    const value = Number(event.target.value);
    setItemsToShow(value);
    fetchInvoices(value);
  };

  filteredRows = filteredRows.slice(0, itemsToShow);

  const handleSelectAll = (event) => {
    setSelectedRows(
      event.target.checked ? filteredRows.map((row) => row.id) : []
    );
  };

  const handleOpenRepModal = () => {
    setOpenRepModal(true);
  };
  const handleRowSelect = (event, row) => {
    setSelectedRows((prev) =>
      event.target.checked
        ? [...prev, row.id]
        : prev.filter((id) => id !== row.id)
    );
    console.log(selectedRows);
  };

  const handlePrint = () => {
    if (selectedRows.length === 0) {
      alert("لا يوجد بيانات للطباعة");
      return;
    }
    let data = [];
    filteredRows.forEach((row) => {
      if (selectedRows.includes(row.id)) {
        data.push(row);
      }
    });
    console.log(data);
    printRepInvoicesSingle(data);
  };
  const handleOpenModal = () => {
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setSelectedStatus("");
    setStatusMessage(null);
  };

  const handleStatusChange = (event) => {
    setSelectedStatus(event.target.value);
  };

  const handleUpdateStatus = async () => {
    try {
      await putData("Invoice/update-invoice-status", {
        InvoiceIds: selectedRows,
        InvoiceStatus: selectedStatus,
      });
      setStatusMessage("تم تعديل حالة الفاتورة بنجاح");
      await fetchInvoices(itemsToShow);
    } catch (error) {
      Swal.fire("Error", error.response.data.message, "error");
      console.error("Error updating status:", error);
    } finally {
      handleCloseModal();
    }
  };

  const handleUpdateRepresentative = async () => {
    try {
      const requestBody = {
        invoiceIds: selectedRows,
        newRepresentativeId: selectedRepresentative,
        dateDaily: new Date(selectedDate).toISOString(),
      };
      console.log(requestBody);
      await putData("Invoice/update-representative-invoices", requestBody);
      setStatusMessage("تم تعديل المندوب بنجاح");
      window.location.reload();
    } catch (error) {
      console.error("Error updating representative:", error);
      setStatusMessage(error.response.data.message);
    } finally {
      setStatusMessageModalOpen(true);
      setOpenRepModal(false);
    }
  };

  const handleDelayInvoice = async (postponedUntil) => {
    setIsDelayingInvoices(true);
    
    try {
      // Process each selected invoice
      const delayPromises = selectedRows.map(async (invoiceId) => {
        const requestBody = {
          isPostponed: true,
          postponedUntil: new Date(postponedUntil).toISOString(),
        };
        
        return await putData(`Invoice/postpone/${invoiceId}`, requestBody);
      });

      await Promise.all(delayPromises);
      
      setStatusMessage("تم تأجيل الفواتير بنجاح");
      setShowDelayModal(false);
      setSelectedRows([]);
      await fetchInvoices(itemsToShow);
      setStatusMessageModalOpen(true);
    } catch (error) {
      console.error("Error delaying invoices:", error);
      Swal.fire({
        icon: "error",
        title: "خطأ",
        text: error.response?.data?.message || "حدث خطأ أثناء تأجيل الفواتير",
      });
    } finally {
      setIsDelayingInvoices(false);
    }
  };

  const handleOpenDelayModal = () => {
    setShowDelayModal(true);
  };

  const handleCloseDelayModal = () => {
    if (!isDelayingInvoices) {
      setShowDelayModal(false);
    }
  };

  if (loading) return <CircularProgress />;
  if (error) {
    return (
      <div style={{ textAlign: "center", marginTop: "20px" }}>
        <Typography variant="h6" color="error">
          {error}
        </Typography>
        <img
          src="/403.png"
          alt="403 Forbidden"
          style={{ maxWidth: "100%", height: "auto" }}
        />
      </div>
    );
  }
  const handleClearSearch = () => {
    // Clear the values using refs
    invoiceCodeRef.current.value = "";
    invoiceDateRef.current.value = "";
    customerRef.current.value = "";
    addressRef.current.value = "";
    governorateRef.current.value = "";
    phoneRef.current.value = "";
    invoiceCategoriesRef.current.value = "";
    dateCreatedRef.current.value = "";
    userNameRef.current.value = "";
    statusRef.current.value = "";
    totalPriceRef.current.value = "";

    setSearchTerms({
      invoiceCode: "",
      invoiceDate: "",
      customer: "",
      address: "",
      governorate: "",
      phone: "",
      invoiceCategories: "",
      dateCreated: "",
      userName: "",
      status: "",
      totalPrice: "",
    });
  };
  const renderSearchInput = (column, placeholder, ref) => (
    <td key={column}>
      <input
        type={
          column === "dailyDate" || column === "invoiceDate" ? "date" : "text"
        }
        placeholder={placeholder}
        value={searchTerms[column] || ""}
        onChange={(e) => handleSearch(column, e.target.value)}
        ref={ref}
        className="w-full px-3 py-1 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
      />
    </td>
  );

  return (
    <div className=" font-medium">
      <Paper>
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "space-between",
            padding: "0 16px",
          }}
        >
          <div className="flex flex-wrap  items-center gap-10">
            <Button
              onClick={() => handleExportToExcel(filteredRows, selectedRows)}
            >
              <FontAwesomeIcon icon={faSave} /> تصدير إلى Excel
            </Button>
            <button
              className="px-4 my-3 py-2 bg-red-500 text-white font-semibold rounded-lg hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-opacity-50"
              onClick={handleClearSearch}
            >
              مسح
            </button>
          </div>
          <h3 className="my-3 text-slate-700 font-medium">
            عدد الفواتير المحددة: {selectedRows.length}
          </h3>
          <h3 className="my-3 text-slate-700 font-medium">
            عدد الفواتير الكلي: {rows.data.length}
          </h3>

          <div className="flex  items-center gap-10">
            <select
              value={itemsToShow}
              onChange={handleItemsToShowChange}
              className=" p-1 md:p-2 lg:px-4 text-center my-3 lg:py-2 bg-blue-500 text-white font-normal rounded-lg"
            >
              <option value={10}>10</option>
              <option value={20}>20</option>
              <option value={30}>30</option>
              <option value={40}>40</option>
              <option value={50}>50</option>
              <option value={75}>75</option>
              <option value={100}>100</option>
              <option value={150}>150</option>
              <option value={200}>200</option>
              <option value={300}>300</option>
              <option value={400}>400</option>
              <option value={500}>500</option>
              <option value={750}>750</option>
              <option value={1000}>1000</option>
              <option value={1500}>1500</option>
              <option value={2000}>2000</option>
              {/* <option value={filteredRows.length}>All</option> */}
            </select>
            <Button onClick={() => handlePrint()}>
              <FontAwesomeIcon icon={faPrint} /> طباعة
            </Button>
          </div>
        </div>
        <TableContainer>
          <div className="overflow-x-auto">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-50">
                {/* Search Inputs Row */}
                <tr>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    <input type="checkbox" className="form-checkbox" />
                  </th>
                  {rows.data && rows.data.length > 0 && (
                    <>
                      {renderSearchInput("invoiceCode", "كود", invoiceCodeRef)}
                      {renderSearchInput(
                        "invoiceDate",
                        "التاريخ",
                        invoiceDateRef
                      )}
                      {renderSearchInput("customer", "العميل", customerRef)}
                      {renderSearchInput("createdBy", "السكرتريه", customerRef)}
                      {renderSearchInput("address", "العنوان", addressRef)}
                      {renderSearchInput(
                        "governorate",
                        "المحافظة",
                        governorateRef
                      )}
                      {renderSearchInput("phone", "الهاتف", phoneRef)}
                      {renderSearchInput(
                        "invoiceCategories",
                        "الفئات",
                        invoiceCategoriesRef
                      )}
                      {renderSearchInput(
                        "dailyDate",
                        "تاريخ اضافه مندوب",
                        dateCreatedRef
                      )}
                      {renderSearchInput("fullName", "المندوب", userNameRef)}
                      {renderSearchInput("status", "الحالة", statusRef)}
                      {renderSearchInput(
                        "totalPrice",
                        "الإجمالي",
                        totalPriceRef
                      )}
                    </>
                  )}
                </tr>

                {/* Header Row */}
                <tr>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    <input
                      type="checkbox"
                      className="form-checkbox"
                      checked={selectedRows.length === filteredRows.length}
                      onChange={handleSelectAll}
                    />
                  </th>
                  <th className="p-1 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">
                    كود
                  </th>
                  <th className="p-1 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">
                    التاريخ
                  </th>
                  <th className="p-1 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">
                    العميل
                  </th>
                  <th className="p-1 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">
                    السكرتيره
                  </th>
                  <th className="p-1 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">
                    العنوان
                  </th>
                  <th className="p-1 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">
                    المحافظة
                  </th>
                  <th className="p-1 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">
                    الهاتف
                  </th>
                  <th className="px-12 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">
                    الفئات
                  </th>
                  <th className="p-1 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">
                    تاريخ اضافه مندوب
                  </th>
                  <th className="p-1 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">
                    المندوب
                  </th>
                  <th className="p-1 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">
                    الحالة
                  </th>
                  <th className="p-1 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">
                    الإجمالي
                  </th>
                  <th className="p-1 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">
                    عرض
                  </th>
                </tr>
              </thead>

              <tbody className="bg-white divide-y divide-gray-200">
                {filteredRows.length > 0 ? (
                  filteredRows.map((row) => (
                    <tr
                      key={row.id}
                      className={
                        selectedRows.includes(row.id)
                          ? "bg-blue-50"
                          : "hover:bg-gray-50"
                      }
                    >
                      <td className="px-6 py-4 whitespace-nowrap">
                        <input
                          type="checkbox"
                          className="form-checkbox"
                          checked={selectedRows.includes(row.id)}
                          onChange={(event) => handleRowSelect(event, row)}
                        />
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap font-bold">
                        {row.invoiceCode}
                      </td>
                      <td className="p-1  break-words whitespace-wrap">
                        {row.invoiceDate.split("T")[0]}
                      </td>
                      <td className="p-1  break-words whitespace-wrap">
                        {row.customer}
                      </td>
                      <td className="p-1  break-words whitespace-wrap">
                        {row?.createdBy || ""}
                      </td>
                      <td className="p-1  break-words whitespace-wrap">
                        {row?.address}
                      </td>
                      <td className="p-1  break-words whitespace-wrap">
                        {row.governorate?.name}
                      </td>
                      <td className="p-1 flex flex-col gap-1">
                        <p>{row.phone}</p>
                        <p>{row?.socendPhone || null}</p>
                      </td>
                      <td className="p-1  break-words whitespace-wrap">
                        {row.invoiceCategories
                          ?.map((cat) => cat.category.name)
                          .join(", ")}
                      </td>
                      <td className="p-1  break-words whitespace-wrap">
                        {row?.dailyDate?.split("T")[0] || "لا يوجد تاريخ"}
                      </td>
                      <td className="p-1  break-words whitespace-wrap">
                        {row.representative?.fullName ?? "لا يوجد مندوب"}
                      </td>
                      <td className="p-1  break-words whitespace-wrap">
                        {row.status}
                      </td>
                      <td className="p-1  break-words whitespace-wrap">
                        {row.totalPrice}
                      </td>
                      <td className="p-1  break-words whitespace-wrap">
                        <button
                          className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 transition-colors"
                          onClick={() => showInvoice(row)}
                        >
                          عرض
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td
                      colSpan={14}
                      className="px-6 py-4 text-center text-gray-500"
                    >
                      No data available
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </TableContainer>
      </Paper>
      <div className="div-open-modal">
        <div className="flex justify-center items-center">
          <div className="all-button">
            {selectedRows.length > 0 && (
              <div>
                <button className="open-modal-button" onClick={handleOpenModal}>
                  تعديل حالة الفاتورة
                </button>
              </div>
            )}
            <div>
              <button
                className="open-modal-button"
                onClick={() => setShowPrintModel(true)}
              >
                طباعه يوميه مندوب
              </button>
            </div>
            <div>
              {selectedRows.length > 0 && (
                <button
                  className="open-modal-button"
                  onClick={handleOpenRepModal}
                >
                  تعديل المندوب
                </button>
              )}
            </div>
            <div>
              {selectedRows.length > 0 && (
                <button
                  className="open-modal-button"
                  onClick={handleOpenDelayModal}
                >
                  تأجيل الفواتير
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
      <Modal open={openModal} onClose={handleCloseModal} dir="rtl">
        <Box sx={{ padding: 4, backgroundColor: "white", borderRadius: 2 }}>
          <Typography variant="h6">تحديث حالة الفواتير</Typography>
          <Select
            value={selectedStatus}
            onChange={handleStatusChange}
            displayEmpty
            fullWidth
            variant="outlined"
            sx={{ marginBottom: 2 }}
          >
            <MenuItem value="" disabled>
              اختر الحالة الجديدة
            </MenuItem>
            <MenuItem value={1}>جديد</MenuItem>
            <MenuItem value={2}>تحت التجهيز</MenuItem>
            <MenuItem value={3}>تم التسليم</MenuItem>
            <MenuItem value={4}>مرتجع</MenuItem>
            <MenuItem value={5}>ملغي</MenuItem>
          </Select>
          <Button
            variant="contained"
            color="primary"
            onClick={handleUpdateStatus}
          >
            تأكيد
          </Button>
          <Button
            variant="outlined"
            onClick={handleCloseModal}
            style={{ marginRight: 8 }}
          >
            إلغاء
          </Button>
        </Box>
      </Modal>
      {openRepModal && (
        <Modal
          open={openRepModal}
          onClose={() => {
            window.location.reload();
            setOpenRepModal(false);
          }}
          dir="rtl"
        >
          <Box sx={{ padding: 4, backgroundColor: "white", borderRadius: 2 }}>
            <Typography variant="h6">تحديث المندوب</Typography>
            <RepresentativeSelector
              value={selectedRepresentative}
              onChange={(e) => setSelectedRepresentative(e.target.value)}
              label="اختر المندوب"
              sx={{ marginBottom: 2 }}
            />
            <TextField
              variant="outlined"
              label="التاريخ"
              type="date"
              fullWidth
              value={selectedDate}
              onChange={(e) => setSelectedDate(e.target.value)}
              InputLabelProps={{ shrink: true }}
              sx={{ marginBottom: 2 }}
            />
            <Button
              variant="contained"
              color="primary"
              onClick={handleUpdateRepresentative}
            >
              تأكيد
            </Button>
            <Button
              variant="outlined"
              onClick={() => setOpenRepModal(false)}
              style={{ marginRight: 8 }}
            >
              إلغاء
            </Button>
          </Box>
        </Modal>
      )}
      {showPrintModel && (
        <Modal
          open={showPrintModel}
          onClose={() => setOpenRepModal(false)}
          dir="rtl"
        >
          <Box sx={{ padding: 4, backgroundColor: "white", borderRadius: 2 }}>
            <Typography variant="h6">طباعه يوميه المندوب</Typography>
            <RepresentativeSelector
              value={selectedRepresentative}
              onChange={(e) => setSelectedRepresentative(e.target.value)}
              label="اختر المندوب"
              sx={{ marginBottom: 2 }}
            />
            <TextField
              variant="outlined"
              label="التاريخ"
              type="date"
              fullWidth
              value={selectedDate}
              onChange={(e) => setSelectedDate(e.target.value)}
              InputLabelProps={{ shrink: true }}
              sx={{ marginBottom: 2 }}
            />
            <Button
              variant="contained"
              color="primary"
              onClick={handelPrintDaily}
            >
              طباعه
            </Button>
            <Button
              variant="outlined"
              onClick={() => setShowPrintModel(false)}
              style={{ marginRight: 8 }}
            >
              إلغاء
            </Button>
          </Box>
        </Modal>
      )}
      <Modal
        open={statusMessageModalOpen}
        onClose={() => setStatusMessageModalOpen(false)}
        dir="rtl"
      >
        <Box sx={{ padding: 4, backgroundColor: "white", borderRadius: 2 }}>
          <Typography variant="h5" sx={{ padding: 2, borderRadius: 2 }}>
            {statusMessage}
          </Typography>
          <Button
            variant="contained"
            color="primary"
            onClick={() => setStatusMessageModalOpen(false)}
          >
            إغلاق
          </Button>
        </Box>
      </Modal>

      {/* Delay Invoice Dialog */}
      <DelayInvoiceDialog
        open={showDelayModal}
        onClose={handleCloseDelayModal}
        selectedInvoicesCount={selectedRows.length}
        onConfirm={handleDelayInvoice}
        isLoading={isDelayingInvoices}
      />
    </div>
  );
};

export default DataTable;
